module.exports = __webpack_public_path__ + "static/media/8OLA6.11c634d4.jpg";